import { render, staticRenderFns } from "./BottomSingle.vue?vue&type=template&id=246c48e9&scoped=true&"
import script from "./BottomSingle.vue?vue&type=script&lang=ts&"
export * from "./BottomSingle.vue?vue&type=script&lang=ts&"
import style0 from "./BottomSingle.vue?vue&type=style&index=0&id=246c48e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246c48e9",
  null
  
)

export default component.exports